import { render } from "./Vehicles.vue?vue&type=template&id=05b55dca"
import script from "./Vehicles.vue?vue&type=script&lang=js"
export * from "./Vehicles.vue?vue&type=script&lang=js"
script.render = render

export default script